<template>

  <el-popover trigger="hover" width="300px" placement="bottom-start">
    <i class="more-info-icon el-icon-question" slot="reference" />
    <h4 class="form-section-header mb-5">
      Manual provision settings
    </h4>
    <vxe-table
      round
      border="inner"
      class="user-stats-table"
      :data="data"
      :show-header="false"
    >
      <vxe-table-column
        field="key"
        min-width="150"
      />
      <vxe-table-column
        field="value"
        min-width="150"
      />
    </vxe-table>
    <el-button
      class="mt-10"
      v-if="canGenerateCreds"
      type="primary"
      @click="generateAuthCreds"
    >
      Generate new secret
    </el-button>
  </el-popover>


</template>

<script>

import feathersClient from "../../../../feathers/feathers-client";

export default {
  name: 'ExtensionConnectionInfo',
  props: {
    data: {required: true}
  },
  computed: {
    canGenerateCreds(){
      return +this.$store.state.auth.user.userRole === 1
    }
  },
  methods: {

    async generateAuthCreds(){
      const {value: peer} = this.data.find(item => item.key === 'SIP Username');
      feathersClient.service('sbc-management').create({
        command: 'generatePeerSecret',
        peer,
        rebootDevices: true
      }).then( res => {
        this.$emit('credsGenerated', res);
      });
    }

  }
}

</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.more-info-icon{
  font-size: 18px;
  color: $voxo-blue;
  margin-left: 5px;
  align-self: flex-end;
  margin-bottom: 5px;
}

</style>
